// extracted by mini-css-extract-plugin
export default {"details":"MZ2RdeaY","adress":"mKgaPT9Q","mobile":"mobile","captionWrapper":"kefz1HIw"};